<template>
    <v-card variant="outlined" class="section-card">
        <div class="section-card-header">
            <v-avatar size="34" color="#e0e7ff" class="section-icon">
                <v-icon color="#4f46e5">mdi-account-edit-outline</v-icon>
            </v-avatar>
            <div>
                <h2 class="section-title">Informations personnelles</h2>
                <p class="section-subtitle">Identité, structure et profil de l'utilisateur</p>
            </div>
        </div>

        <v-divider></v-divider>

        <div class="section-card-body">
            <v-form @submit.prevent="updateUser">
                <user-fields :isLoading="isLoading" :edit="true" :fields="fields" :errors="errors" />
                <div class="my-2"></div>
                <v-btn type="submit" theme="dark" color="#4f46e5" class="submit-button" :loading="isLoading">
                    <v-icon start>mdi-content-save-outline</v-icon> Enregistrer
                </v-btn>
            </v-form>
        </div>
    </v-card>
</template>

<script>
import UserFields from './UserFields.vue';

export default {
    name: 'UserEditInfo',
    props: {
        userId: { required: true },
        isLoading: { type: Boolean, required: true }
    },
    components: { UserFields },
    data() {
        return {
            fields: {
                prenom: '',
                nom: '',
                matricule: '',
                email: '',
                etablissement: '',
                role: ''
            },
            errors: {
                prenom: '',
                nom: '',
                matricule: '',
                email: '',
                etablissement: '',
                role: ''
            }
        };
    },
    created() {
        this.fetchUser();
    },
    methods: {
        fetchUser() {
            this.$emit('load', true);
            axios
                .get(`/users/${this.userId}`)
                .then((response) => {
                    this.fields = response.data.data;
                    this.$emit('userFetched', response.data.data);
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur !',
                        text: error.message
                    });
                })
                .finally(() => {
                    this.$emit('load', false);
                });
        },
        updateUser() {
            this.$emit('load', true);
            axios
                .patch(`/users/${this.userId}`, { ...this.fields, etablissement_id: this.fields.etablissement.id })
                .then((response) => {
                    if (response.data.success == true) {
                        this.$swal({
                            icon: 'success',
                            title: 'Opération réussie',
                            text: response.data.message
                        });
                        if (this.$store.getters['auth/user'].id === response.data.data.id) {
                            this.$store.commit('auth/SET_LOGGED_USER_INFO', { user: response.data.data });
                        }
                        this.errors = {
                            prenom: '',
                            nom: '',
                            matricule: '',
                            email: '',
                            structure: '',
                            profile: ''
                        };
                        // this.$router.push({ name: 'UserShow', params: {userId: this.userId} });
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: 'Erreur !',
                            text: response.data.message
                        });
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur !',
                        text: error.message
                    });
                    if (error.errors != undefined) {
                        Object.keys(error.errors).forEach((key) => {
                            this.errors[key] = error.errors[key][0];
                        });
                    }
                })
                .finally(() => {
                    this.$emit('load', false);
                });
        }
    }
};
</script>

<style scoped>
.section-card {
    border-radius: 12px;
}
.section-card-header {
    align-items: center;
    display: flex;
    gap: 16px;
    padding: 12px 16px;
}
.section-title {
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
}
.section-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    margin: 2px 0 0;
}
.section-card-body {
    padding: 16px;
}
.submit-button {
    border-radius: 8px;
    box-shadow: none;
    height: 38px;
    padding: 0 24px;
    text-transform: none;
}
</style>
